import { MainOptions, OptionsMap } from "./OptionsDataTypes"

export enum Destination {
    AbuDhabi = "Abu Dhabi",
    Dubai = "Dubai",
    Maldives = "Maldives",
    Mauritius = "Mauritius",
    Seychelles = "Seychelles",
    SouthernAfrica = "Southern Africa",
    SriLanka = "Sri Lanka",
    All = "All"
}


export type DestinationType = {
    id : number
    destination : string
    selected : boolean
}

export interface DestinationOption {
    id : number;
    destination: Destination;
    options?: OptionsMap;
    selected: boolean;
}
